/**
 * @Note
 * this hasn't been used anywhere yet, but can come in handy
 * if we need any global state in kyc. So leaving it here as is.
 *
 * @todo
 * remove this if unused after ALL KYC flows ( judged by `flowType`)
 * are done on web.
 */

import { createContext, useContext, useReducer } from 'react'
import { AllKycScreenRouteNames } from '../utils/config'
import { CommonUIStateType } from '@/components/kyc/utils/types'
import { WithChildren } from '@/root/types/utilities'

const defaultState: CommonUIStateType = {
  latestKYCScreen: 'ACCOUNT_CREATION_INTRO',
}

type Action = {
  type: 'UPDATE_LATEST_IVR_ROUTE'
  payload: {
    latestIvrRoute: AllKycScreenRouteNames
  }
}

type Dispatch = (action: Action) => void

export const KYCCommonUIContext = createContext<
  | { kycCommonUIState: CommonUIStateType; kycCommonUIDispatch: Dispatch }
  | undefined
>(undefined)

export function useKycCommonUIState() {
  const context = useContext(KYCCommonUIContext)

  if (context === undefined) {
    throw new Error(
      'useKycCommonUIState must be used within a KYCCommonUIContext Provider',
    )
  }

  return context
}

function reducer(state: CommonUIStateType, action: Action) {
  switch (action.type) {
    case 'UPDATE_LATEST_IVR_ROUTE': {
      return {
        ...state,
        latestKYCScreen: action.payload.latestIvrRoute,
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export default function KycCommonUIStateProvider({ children }: WithChildren) {
  const [state, dispatch] = useReducer(reducer, defaultState)

  return (
    <KYCCommonUIContext.Provider
      value={{
        kycCommonUIState: state,
        kycCommonUIDispatch: dispatch,
      }}
    >
      {children}
    </KYCCommonUIContext.Provider>
  )
}
